import React from 'react'
import { FormRecuperaPassword, Page } from 'components/organisms'

const RecuperaPasswordTemplate = ({ pagina }: { pagina: any }) => (
  <Page
    hideBreadcrumbs
    pagina={pagina}
    containerVariant="xs"
    className="recupera-password-template"
    contentStyle="basic"
    backButton={{
      label: 'Torna al login',
      href: '/login',
    }}
  >
    <FormRecuperaPassword />
  </Page>
)

export default RecuperaPasswordTemplate
